import React from 'react';
import { useParams } from 'react-router-dom';
import {
  IconCircleCheck, IconCalendar, IconClock, IconMapPin, IconCalendarPlus,
} from '@tabler/icons-react';
import { Avatar, Button, Skeleton, StatusBadge } from '../../components/common';
import appointmentApi from '../../api/appointment/appointmentApi';
import useFetch from '../../hooks/useFetch';
import { useClinic } from '../../context/ClinicContext';
import { downloadIcs } from '../../services/calendarService';
import { PATHS, toPath } from '../../routes/paths';
import { formatDayDate, formatTime } from '../../utils/date';

export default function BookingSuccessPage() {
  const { id } = useParams();
  const { clinic } = useClinic();
  const { data: a } = useFetch(() => appointmentApi.get(id), [id]);
  const pending = a?.status === 'pending';

  return (
    <div className="page page--white success">
      <div className="success__body">
        <span className="success__icon"><IconCircleCheck size={40} /></span>
        <h1 className="success__title">{pending ? 'Booking request sent' : 'You’re booked in'}</h1>
        <p className="success__text">
          {pending
            ? 'The clinic will confirm your appointment shortly. We’ll let you know by SMS.'
            : 'We’ll send you an SMS reminder before your visit.'}
        </p>

        {!a ? <Skeleton height={180} /> : (
          <div className="card card--pad success__card">
            <div className="u-flex u-items-center u-gap-3">
              <Avatar name={a.doctor?.name} size="sm" />
              <div className="u-grow">
                <p className="u-bold">{a.doctor?.name}</p>
                <p className="u-muted u-text-sm">{a.doctor?.specialty}</p>
              </div>
              <StatusBadge status={a.status} short />
            </div>
            <div className="list-row u-mt-3">
              <span className="icon-tile"><IconCalendar size={20} /></span>
              <span>{formatDayDate(a.date)}</span>
            </div>
            <div className="list-row">
              <span className="icon-tile"><IconClock size={20} /></span>
              <span>{formatTime(a.time)}</span>
            </div>
            <div className="list-row">
              <span className="icon-tile"><IconMapPin size={20} /></span>
              <span>{clinic?.address}</span>
            </div>
          </div>
        )}
      </div>
      <div className="success__actions">
        {a && (
          <Button variant="outline" block onClick={() => downloadIcs({ appointment: a, clinic })}>
            <IconCalendarPlus size={20} />
            Add to calendar
          </Button>
        )}
        <Button block to={a ? toPath(PATHS.appointmentDetail, { id: a.id }) : PATHS.appointments}>View appointment</Button>
        <Button variant="ghost" block to={PATHS.home} className="success__home">Back to home</Button>
      </div>
    </div>
  );
}
